export default "__VITE_ASSET__4d391e6b__"